import React, { useState } from "react";
import { Modal, ModalFooter, Button, Icon, TextArea, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useMutation } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { createCoEditionRequest } from "../../api/coEditionRequestService";
import css from "../title/EntityRow.module.css";
export var CoEditionRequestModal = function (_a) {
    var productId = _a.productId, coPublisherName = _a.coPublisherName, onClose = _a.onClose, onCreated = _a.onCreated, onError = _a.onError;
    var formatMessage = useIntl().formatMessage;
    var ky = useOkapiKy();
    var _b = useState(""), note = _b[0], setNote = _b[1];
    var createMutation = useMutation(function () {
        return createCoEditionRequest(ky, {
            productId: productId,
            note: note.trim() || undefined,
        });
    }, {
        onSuccess: function () {
            onCreated();
        },
        onError: function () {
            onError(formatMessage({
                id: "ui-br-agency.co-edition.request.error.createFailed",
            }));
        },
    });
    var footer = (React.createElement(ModalFooter, null,
        React.createElement(Button, { buttonStyle: "primary", disabled: createMutation.isLoading, onClick: function () { return createMutation.mutate(); } }, createMutation.isLoading ? (React.createElement(React.Fragment, null,
            React.createElement(Icon, { icon: "spinner-ellipsis", size: "small" }),
            React.createElement(FormattedMessage, { id: "ui-br-agency.button.saving" }))) : (React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.request.submit" }))),
        React.createElement(Button, { onClick: onClose, disabled: createMutation.isLoading },
            React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" }))));
    return (React.createElement(Modal, { open: true, dismissible: true, onClose: onClose, size: "small", label: formatMessage({
            id: "ui-br-agency.co-edition.request.modal.title",
        }), footer: footer },
        React.createElement("div", { className: css.assignBody },
            coPublisherName && (React.createElement("div", { className: css.assignLine },
                React.createElement("span", { className: css.fieldLabel },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.request.field.coPublisher" })),
                React.createElement("span", null, coPublisherName))),
            React.createElement(TextArea, { label: formatMessage({
                    id: "ui-br-agency.co-edition.request.field.note",
                }), value: note, onChange: function (event) {
                    return setNote(event.target.value);
                } }))));
};
